import { render, staticRenderFns } from "./stopcarlist.vue?vue&type=template&id=8bd9dd72&scoped=true&"
import script from "./stopcarlist.vue?vue&type=script&lang=js&"
export * from "./stopcarlist.vue?vue&type=script&lang=js&"
import style0 from "./stopcarlist.vue?vue&type=style&index=0&id=8bd9dd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd9dd72",
  null
  
)

export default component.exports